var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#D7DDDD;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000122704236748374683120000012402957843033448599_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000098197705911788952850000017416751865890436489_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19.1,
    className: "st2",
    width: 28,
    height: 28
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_00000026882142817231426590000003274882376405393084_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_00000021100917229563143830000000405069243192434817_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 32,
    cy: 33.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 32,
    y1: 34.9,
    x2: 32,
    y2: 38.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.7,24.3h18.5c0.5,0,0.9,0.4,0.9,0.9v16.8c0,0.5-0.4,0.9-0.9,0.9H22.7c-0.5,0-0.9-0.4-0.9-0.9V25.2 C21.9,24.7,22.2,24.3,22.7,24.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 26.3,
    y1: 22.5,
    x2: 26.3,
    y2: 26.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 37.7,
    y1: 22.5,
    x2: 37.7,
    y2: 26.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 21.9,
    y1: 28.7,
    x2: 42.1,
    y2: 28.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon02);
export default __webpack_public_path__ + "static/media/feature-tile-icon-02.7d7f69e37b41ad65c11e7caec28b0705.svg";
export { ForwardRef as ReactComponent };